import { defineMessages } from 'react-intl';

export const messages: {
    loadingLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	loadingLabel: {
		id: 'navigation.global-invite.loading-visually-hidden-label',
		description: 'Visually hidden text to indicate the invite people UI is loading.',
		defaultMessage: 'Loading',
	},
});
